import { getSolutionValueDecimal } from "./getSolutionValueDecimal.ts";
import { SolutionMap, SolutionOptionKey } from "@labs/shared/types/Solution.ts";

export const getTotalElectricityPurchase = (
  solutionMap: SolutionMap,
): number => {
  const coGen = getSolutionValueDecimal(
    solutionMap,
    SolutionOptionKey.CoGenerationElectricity,
  );
  const cleanPowerPurchase = getSolutionValueDecimal(
    solutionMap,
    SolutionOptionKey.RenewablePurchaseFromUtilityElectricity,
  );
  const cleanPPA = getSolutionValueDecimal(
    solutionMap,
    SolutionOptionKey.RenewableEnergyAsPpaVppaElectricity,
  );
  const recs = getSolutionValueDecimal(
    solutionMap,
    SolutionOptionKey.RenewableCreditsRecsElectricity,
  );
  const onsiteGeneration = getSolutionValueDecimal(
    solutionMap,
    SolutionOptionKey.OnsiteSolarOrRenewableEnergyGenerationElectricity,
  );

  return coGen + cleanPowerPurchase + cleanPPA + recs + onsiteGeneration;
};
